import moment, { Moment } from 'moment';

export function getTokenRemainingTtl(expiration: Moment): number {
    return moment.duration(expiration.diff(moment())).asMinutes();
}

export function isTokenExpired(expiration: Moment): boolean {
    return !expiration.isAfter(moment());
}
